import React, { useState } from 'react'
import { useApartmentContantDetail } from '../../assets/api/useAdminApi';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import CustomPagination from '../../shared/utils/CustomPagination';
import { Box, Tooltip, Typography } from '@mui/material';
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import EditIcon from '@mui/icons-material/Edit';
import useContactPersonStore from '../../store/useContactPersonStore';
import useAuthStore from '../../store/useAuthStore';

const CommonContactPersonTable = ({ id }) => {
    const {user}=useAuthStore()
    const { setContactperson } = useContactPersonStore()
    const [payoutPaginationModel, setPayoutPaginationModel] = useState({ page: 0, pageSize: 5 });
    const { data: contactperson, isLoading: iscontactLoading } = useApartmentContantDetail({ apartment_id: id })
    const conatactRows = contactperson?.data?.contacts?.map((item, index) => ({
        id: index + 1,
        sr_no: index + 1,
        ...item
    })) || [];
    const ContactColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 0.5,
            renderCell: (params) => <Typography variant="body1">{params.value}</Typography>
        },
        {
            field: "name",
            headerName: "Name",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "mobile_no",
            headerName: "Mobile no",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "designation",
            headerName: "Designation",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },



        // ...(!["Zonal Coordinator", "Marketing Manager"].includes(user?.role)
        //     ? [
        //         {
        //             field: "actions",
        //             type: "actions",
        //             headerName: "Actions",
        //             flex: 1,
        //             cellClassName: "actions",
        //             renderCell: (params) => (
        //                 <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
        //                     <Tooltip title="Edit">
        //                         <GridActionsCellItem
        //                             key={0}
        //                             icon={<EditIcon />}
        //                             label="Edit"
        //                             onClick={() => {
        //                                 const selectedcontactperson = conatactRows?.find(row => row?.id === params?.id);
        //                                 if (selectedcontactperson) {
        //                                     setContactperson(selectedcontactperson)
        //                                 }
        //                             }}
        //                         />
        //                     </Tooltip>
        //                 </Box>
        //             ),
        //         },
        //     ]
        //     : []),


    ];
    return (
        <>

            {iscontactLoading ? (
                <DataGridSkeleton rowsNum={5} />
            ) : (
                <DataGrid
                    rows={conatactRows}
                    columns={ContactColumns}
                    pagination
                    paginationModel={payoutPaginationModel}
                    onPaginationModelChange={setPayoutPaginationModel}
                    pageSizeOptions={[5]}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={payoutPaginationModel}
                                setPaginationModel={setPayoutPaginationModel}
                                totalRows={conatactRows?.length || 0}
                                pageSize={payoutPaginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )
            }
        </>
    )
}

export default CommonContactPersonTable